import React, { useEffect, useState, useRef } from 'react'
import {
  Get_tickets,
  privatenotes,
  update_tickets,
  GetChatLog,
  delete_tickets
} from '../../services/data'
import useDebounce from '../../hooks/useDebounce'
import IonIcon from '@reacticons/ionicons'
import { toast, ToastContainer } from 'react-toastify'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { format } from 'date-fns'
import TrainFilterDropdownPopup from '../../components/trainfilterdropdownpopup'
import FilterDropDownHook from '../../hooks/filterdropdownhook'
import useRippleEffect from '../../hooks/tripleEffects'
import { TfiFilter } from 'react-icons/tfi'
import { Tooltip } from 'react-tooltip'
import ReplyTextEditor from '../Chats/replytexteditor'
import AddPrivateNotes from './component/privatenotesadd'
import EditPrivateNotes from './component/updatenotesupdate'
import DateTimeFormat from '../../util/DateTimeformat'
import PrivateNotesWithDraggable from './component/notesdraggable'
import TooltipWalkthrough from '../../util/walkthrough'
import { useSubscription } from '../../context/subscriptionprovider'
import AccessRestrictedOverlay from '../../components/restrictoverlay'
import useChatbotLoader from '../../util/chatbotloader'
import Loader from '../../components/loader'
import SettingsPopup from './component/settingspopup'
import validateJSON from '../../util/jsonvalidation'
import TicketPreviewModal from './component/ticketpreviewmodal'
import TicketTable from './component/tickettable'
import { useLocation, useParams } from 'react-router-dom'

const TicketManagement = () => {
  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const storeid = getStoreIdFromUrl()
  const [tickets, setTickets] = useState([])
  const [search, setSearch] = useState('')
  const [statusfilter, setstatusfilter] = useState('')
  const [priorityfilter, setpriorityfilter] = useState('')
  const [datefilter, setdatefilter] = useState('')
  const [customer_search, setcustomer_search] = useState('')
  const debouncedSearchTerm = useDebounce(search, 2000)
  const debouncedCustomerSearchTerm = useDebounce(customer_search, 2000)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totaltickets, settotaltickets] = useState(1)
  const [customerpreview, setcustomerpreview] = useState(false)
  const [previewticket, setpreviewticket] = useState([])
  const [referenceId, SetreferenceID] = useState('')
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [onfiltering, setonfiltering] = useState(false)
  const store_id = storeid ?? ''
  const cust_id = localStorage.getItem('chatlog_customer_id') ?? ''
  const chatLog = new GetChatLog()
  const { ripple, createRipple } = useRippleEffect()
  const { handleopenClosedropdown, isopenpopup, closefilterpopupeye } =
    FilterDropDownHook()
  const datepickerref = useRef(null)
  const [error, setError] = useState('')
  const [activechatlogTab, setActiveChatlogTab] = useState('Conversation')
  const [openaddprivatenotes, Setopenaddprivatenotes] = useState(false)
  const [openupdateprivatenotes, Setopenupdateprivatenotes] = useState(false)
  const [notes, setNotes] = useState([])
  const [passticketid, setpassticketid] = useState('')
  const [passnoteid, setpassnoteid] = useState('')
  const [passticketnotes, setpassticketnotes] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)
  const [hoveredNote, setHoveredNote] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const [previewstatuschange, setpreviewstatuschange] = useState(
    previewticket.status || 'open'
  )
  const [loading, setLoading] = useState(true)
  const [previewpriority, setpreviewpriority] = useState(
    previewticket.priority || 'Highest'
  )
  const [SettingsPopupOpen, SetSettingsPopupOpen] = useState(false)
  const [isSpinning, setIsSpinning] = useState(false)
  const notesService = new privatenotes()
  const { isRestricted, activePlan, limitedPermission } = useSubscription()
  const [runTour, setRunTour] = useState(false)
  const [tourStep, setTourStep] = useState(0)
  const [Deleteticket, SetDeleteticket] = useState('')

  useEffect(() => {
    setpreviewstatuschange(previewticket.status)
  }, [previewticket.status])

  useEffect(() => {
    setpreviewpriority(previewticket.priority)
  }, [previewticket.priority])

    useEffect(() => {
    const handleOpenSettings = () => {
      SetSettingsPopupOpen(true)
      setcustomerpreview(false)
    }

    window.addEventListener('openSettings', handleOpenSettings)

    return () => {
      window.removeEventListener('openSettings', handleOpenSettings)
    }
  }, [])

  const closefilterpopup = () => {
    handleopenClosedropdown()
  }

  const fetchNotes = async ticketid => {
    try {
      const response = await notesService.getNotes(storeid, ticketid)
      if (response) setNotes(response.data)
    } catch {}
  }

  useEffect(() => {
    if (
      isRestricted ||
      !limitedPermission ||
      limitedPermission.ticket_management === false
    )
      return
    fetchNotes()
  }, [isRestricted, limitedPermission])

  useEffect(() => {
    const delay = setTimeout(() => {
      setLoading(false)
    }, 800)
    return () => clearTimeout(delay)
  }, [isRestricted, activePlan, limitedPermission])

  const fetchTickets = async (params = {}) => {
    const {
      customerId = '',
      status = '',
      priority = '',
      page = 1,
      searchTerm = '',
      ticketNumber = 0,
      sort = '',
      customer_search = '',
      created_at_from = '',
      created_at_to = ''
    } = params

    try {
      const response = await Get_tickets(
        store_id,
        customerId,
        10,
        status,
        priority,
        page,
        searchTerm,
        ticketNumber,
        sort,
        customer_search,
        created_at_from,
        created_at_to,
        'DESC'
      )

      if (response.success) {
        setTickets(response.data)
        console.log(response.data)
        settotaltickets(response.pagination.total)
        setTotalPages(
          Math.ceil(response.pagination.total / response.pagination.limit)
        )
      } else {
        setTickets([])
      }
    } catch (error) {
      console.error('Error fetching tickets:', error)
    }
  }

  useEffect(() => {
    const handleTourEvent = event => {
      if (event.detail === true) setRunTour(true)
    }
    const handleStepIndex = e => {
      const { stepIndex } = e.detail
      setTourStep(stepIndex)
    }
    window.addEventListener('joyrideStepIndex', handleStepIndex)
    window.addEventListener('triggertutorialwalkthrough', handleTourEvent)
    return () => {
      window.removeEventListener('triggertutorialwalkthrough', handleTourEvent)
      window.removeEventListener('joyrideStepIndex', handleStepIndex)
    }
  }, [])

  useEffect(() => {
    if (debouncedSearchTerm.trim()) {
      let ticketNumber = 0
      let searchTerm = debouncedSearchTerm.trim()
      if (!isNaN(searchTerm) && Number.isInteger(Number(searchTerm))) {
        ticketNumber = Number(searchTerm)
        searchTerm = ''
      }
      fetchTickets({ searchTerm, ticketNumber })
    } else {
      if (onfiltering) {
        const [startDate, endDate] = dateRange
        const params = {
          status: statusfilter || '',
          priority: priorityfilter || '',
          customer_search: customer_search || '',
          created_at_from: startDate
            ? format(new Date(startDate), 'yyyy-MM-dd')
            : '',
          created_at_to: endDate ? format(new Date(endDate), 'yyyy-MM-dd') : ''
        }
        const isFilterApplied = Object.values(params).some(
          value => value !== '' && value !== 0
        )
        fetchTickets(isFilterApplied ? params : {})
      } else {
        if (
          isRestricted ||
          !limitedPermission ||
          limitedPermission.ticket_management === false
        )
          return
        fetchTickets()
      }
    }
  }, [debouncedSearchTerm])

  const handlefilterSubmit = () => {
    const [startDate, endDate] = dateRange
    if (dateRange[0] !== null) {
      if (!dateRange[0]) {
        setError('start dates required.')
        return
      }
      if (!dateRange[1]) {
        setError('end dates required.')
        return
      }
    }
    setError('')
    const params = {
      status: statusfilter || '',
      priority: priorityfilter || '',
      customer_search: customer_search || '',
      created_at_from: startDate
        ? format(new Date(startDate), 'yyyy-MM-dd')
        : '',
      created_at_to: endDate ? format(new Date(endDate), 'yyyy-MM-dd') : ''
    }
    const isFilterApplied = Object.values(params).some(
      value => value !== '' && value !== 0
    )
    setonfiltering(isFilterApplied)
    handleopenClosedropdown()
    fetchTickets(isFilterApplied ? params : {})
  }

  const handleStatusChange = async (ticketid, ticketNumber, newStatus) => {
    setTickets(prevTickets =>
      prevTickets.map(ticket =>
        ticket.ticket_number === ticketNumber
          ? { ...ticket, status: newStatus }
          : ticket
      )
    )
    const ticket_update = await update_tickets(ticketid, newStatus, null)
    if (ticket_update.success) {
      if (!toast.isActive(13, 'ticket')) {
        toast.success(`${ticket_update.message}`, {
          position: 'bottom-center',
          autoClose: true,
          closeOnClick: true,
          toastId: 13
        })
      }
    }
  }

  const handlepriority = async (ticketid, ticketNumber, newPriority) => {
    setTickets(prevTickets =>
      prevTickets.map(ticket =>
        ticket.ticket_number === ticketNumber
          ? { ...ticket, priority: newPriority }
          : ticket
      )
    )
    const ticket_update = await update_tickets(ticketid, null, newPriority)
    if (ticket_update.success) {
      toast.success(`${ticket_update.message}`, { position: 'bottom-center' })
    }
  }

  const handleResetClick = () => {
    setstatusfilter('')
    setdatefilter('')
    setpriorityfilter('')
    setcustomer_search('')
    setDateRange([null, null])
    setTimeout(() => {
      fetchTickets({
        status: '',
        sort: '',
        searchTerm: '',
        customer_search: '',
        created_at_from: '',
        created_at_to: ''
      })
      handleopenClosedropdown()
    }, 0)
  }

  useEffect(() => {
    if (
      isRestricted ||
      !limitedPermission ||
      limitedPermission.ticket_management === false
    )
      return
    fetchTickets({ page: currentPage })
  }, [currentPage])

  const handlePageChange = direction => {
    setCurrentPage(prevPage => {
      if (direction === 'next' && prevPage < totalPages) return prevPage + 1
      else if (direction === 'prev' && prevPage > 1) return prevPage - 1
      return prevPage
    })
  }

  const startItem = (currentPage - 1) * 10 + 1
  const endItem = startItem + tickets.length - 1

  const handleopenpreview = (chat_id, ticket, ticket_id) => {
    console.log(ticket)
    setpreviewticket(ticket)
    setpassticketid(ticket_id)
    SetreferenceID(validateJSON(ticket.meta).reference_chat_id)
    fetchNotes(ticket_id)
    localStorage.setItem('chatlist_customer_id', chat_id)
    localStorage.setItem('chatlog_customer_id', ticket.customer_id)
    setcustomerpreview(true)
    localStorage.removeItem('ticket_reload_done')
    localStorage.removeItem('redirectToticket')
  }
  const handleopenDelete = id => {
    SetDeleteticket(id)
    setShowModal(true)
  }

  const ticket_delete = async id => {
    const delete_response = await delete_tickets(id)
    if (delete_response.success) {
      toast.success(`${delete_response.message}`, { position: 'bottom-center' })
      fetchTickets()
    } else {
      toast.error(`${delete_response.message}`, { position: 'bottom-center' })
    }
  }

  useEffect(() => {
    if (
      isRestricted ||
      !limitedPermission ||
      limitedPermission.ticket_management === false
    )
      return
    fetchTickets()
  }, [isRestricted, limitedPermission])

  const handlepreviewstatuschange = e => {
    const newStatus = e.target.value
    setpreviewstatuschange(newStatus)
    handleStatusChange(
      previewticket.ticket_id,
      previewticket.ticket_number,
      newStatus
    )
  }

  const handlepreviewprioritychange = e => {
    const newPriority = e.target.value
    setpreviewpriority(newPriority)
    handlepriority(
      previewticket.ticket_id,
      previewticket.ticket_number,
      newPriority
    )
  }

  useEffect(() => {
    const handleTriggerTickets = e => {
      console.log('Trigger Tickets Event Fired:', e.detail)

      // e.detail contains the array you passed
      setTickets(e.detail)
    }

    window.addEventListener('triggertickets', handleTriggerTickets)

    return () => {
      // cleanup on unmount
      window.removeEventListener('triggertickets', handleTriggerTickets)
    }
  }, [tickets])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const ticketNumberStoreId = urlParams.get('store_id')
    const ticketNumberFromURL = urlParams.get('ticket_number')
    const ticketSearchFromURL = urlParams.get('message_search')
    const ticketStatusFromURL = urlParams.get('status')
    const ticketsfromredirecturl = urlParams.get('redirectToticket')
    const ticketsfrompriorityurl = urlParams.get('priority')
    const ticketsfromcustomer_search = urlParams.get('customer_search')
    const urlfromCreatedfrom = urlParams.get('created_at_from')
    const urlfromCreatedto = urlParams.get('created_at_to')

    // Reload once if ticket_number exists and this is the first visit
    if (ticketNumberFromURL && !localStorage.getItem('ticket_reload_done')) {
      localStorage.setItem('ticket_reload_done', 'true')

      window.dispatchEvent(
        new CustomEvent('storeSwitchedtrigger', { detail: true })
      )
      window.dispatchEvent(new CustomEvent('storeChanger', { detail: true }))

      window.location.reload()
      return
    }

    // If ticket_number exists and user has permission → fetch & open ticket
    if (limitedPermission && limitedPermission.ticket_management !== false) {
      const fetchAndOpenTicket = async () => {
        try {
          // Open preview for the fetched ticket

          const response = await Get_tickets(
            ticketNumberStoreId || store_id,
            '',
            10,
            ticketStatusFromURL || '', // safe fallback
            ticketsfrompriorityurl || '',
            1,
            ticketSearchFromURL || '',
            ticketNumberFromURL,
            '',
            ticketsfromcustomer_search,
            urlfromCreatedfrom,
            urlfromCreatedto,
            'DESC'
          )

          if (response?.success) {
            const ticket = response.data[0]
            console.log('Fetched Ticket:', ticket)
            if (ticketsfromredirecturl) {
              handleopenpreview(ticket.chat_id, ticket, ticket.ticket_id)
            }
            // ✅ Fixed: set tickets correctly
            setTickets(response.data)
            // fetchTickets({ ticketSearchFromURL, ticketNumberFromURL })
            // window.dispatchEvent(
            //   new CustomEvent('triggertickets', { detail: response.data })
            // )
          }
        } catch (err) {
          console.error('Error opening ticket from URL:', err)
        }
      }

      fetchAndOpenTicket()
    }
  }, [limitedPermission, store_id]) // ✅ cleaned dependencies

  if (loading) {
    return (
      <div className='min-h-[29.1rem] h-full flex items-center justify-center'>
        <div className='text-center text-gray-500 animate-pulse'>
          <Loader />
        </div>
      </div>
    )
  }

  if (
    isRestricted ||
    !limitedPermission ||
    limitedPermission.ticket_management === false
  ) {
    return (
      <div className='min-h-[29.1rem] h-full relative'>
        <AccessRestrictedOverlay
          content={
            'Unlock to manage support tickets effectively with our ticketing system. Upgrade your subscription to enable this feature.'
          }
        />
      </div>
    )
  }

  return (
    <>
      {showModal && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] mx-5 p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
            <div className='block'>
              <div className='w-full flex justify-end items-start '>
                <svg
                  onClick={() => {
                    setShowModal(false)
                  }}
                  width='26'
                  height='26'
                  className='cursor-pointer'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                    fill='#373737'
                  />
                </svg>
              </div>
              <div className=' mt-2 flex flex-col items-center justify-center gap-3'>
                <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                  Delete
                </p>
                <p className='font-[400] text-[16px] leading-[21px] text-center'>
                  Are you sure want to delete?
                </p>
                <div className='flex mt-4 gap-4'>
                  <button
                    onClick={() => {
                      setShowModal(false)
                    }}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      ticket_delete(Deleteticket)
                      SetDeleteticket('')
                      setShowModal(false)
                    }}
                    className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openaddprivatenotes && (
        <AddPrivateNotes
          closePopup={() => {
            Setopenaddprivatenotes(false)
          }}
          ticketid={passticketid}
          refreshNotes={() => fetchNotes(passticketid)}
        />
      )}
      {openupdateprivatenotes && (
        <EditPrivateNotes
          closePopup={() => {
            Setopenupdateprivatenotes(false)
          }}
          ticketid={passticketid}
          ticketnotes={passticketnotes}
          noteid={passnoteid}
          refreshNotes={() => {
            fetchNotes(passticketid)
          }}
        />
      )}
      {customerpreview && (
        <TicketPreviewModal
          previewticket={previewticket}
          previewstatuschange={previewstatuschange}
          handlepreviewstatuschange={handlepreviewstatuschange}
          previewpriority={previewpriority}
          handlepreviewprioritychange={handlepreviewprioritychange}
          setcustomerpreview={setcustomerpreview}
          setActiveChatlogTab={setActiveChatlogTab}
          activechatlogTab={activechatlogTab}
          referenceId={referenceId}
          setIsSpinning={setIsSpinning}
          isSpinning={isSpinning}
          Setopenaddprivatenotes={Setopenaddprivatenotes}
          Setopenupdateprivatenotes={Setopenupdateprivatenotes}
          notes={notes}
          setHoveredNote={setHoveredNote}
          setpassticketid={setpassticketid}
          setpassticketnotes={setpassticketnotes}
          setpassnoteid={setpassnoteid}
          fetchNotes={() => fetchNotes(passticketid)}
          passticketid={passticketid}
        />
      )}
      <div className='relative py-3 px-3'>
        <TicketTable
          tickets={tickets}
          currentPage={currentPage}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          totaltickets={totaltickets}
          statusfilter={statusfilter}
          priorityfilter={priorityfilter}
          startDate={startDate}
          endDate={endDate}
          search={search}
          customer_search={customer_search}
          error={error}
          onfiltering={onfiltering}
          ripple={ripple}
          isopenpopup={isopenpopup}
          datepickerref={datepickerref}
          setstatusfilter={setstatusfilter}
          setpriorityfilter={setpriorityfilter}
          setDateRange={setDateRange}
          setcustomer_search={setcustomer_search}
          setSearch={setSearch}
          SetSettingsPopupOpen={SetSettingsPopupOpen}
          handleStatusChange={handleStatusChange}
          handlepriority={handlepriority}
          handlePageChange={handlePageChange}
          handleopenClosedropdown={handleopenClosedropdown}
          closefilterpopupeye={closefilterpopupeye}
          handleResetClick={handleResetClick}
          handlefilterSubmit={handlefilterSubmit}
          handleopenpreview={handleopenpreview}
          ticket_delete={handleopenDelete}
          createRipple={createRipple}
          closefilterpopup={closefilterpopup}
        />
        {SettingsPopupOpen && (
          <SettingsPopup onclose={() => SetSettingsPopupOpen(false)} />
        )}
      </div>
      <ToastContainer />
      <ToastContainer containerId={'ticket'} />
      <TooltipWalkthrough pageKey={'/ticket-management'} />
    </>
  )
}

export default TicketManagement
